<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>Clients</v-card-title>
          <v-card-text class="pb-0">
            <v-row class="px-3">
              <v-col cols="4" class="py-0">
                <v-text-field v-model="data.firstName_Icontains" label="First name" @keydown.enter="submitSearch" />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-text-field v-model="data.lastName_Icontains" label="Last name" @keydown.enter="submitSearch" />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-text-field v-model="data.email_Icontains" label="Email" @keydown.enter="submitSearch" />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-text-field v-model="data.phone_Icontains" label="Phone" @keydown.enter="submitSearch" />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select
                  :items="corporateChallenges"
                  v-model="data.user_CorporateChallenges_CorporateChallengeId"
                  label="Corporate"
                />
              </v-col>
              <v-col cols="4" class="py-0">
                <v-select
                  :items="products"
                  v-model="data.user_Subscriptions_Product_Type"
                  label="Active subscription"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer />
            <v-btn v-if="Object.keys(search).length > 0" @click="clearSearch"> Clear Search</v-btn>
            <v-btn @click="submitSearch"> Search</v-btn>
          </v-card-actions>
          <v-card-text v-if="clients.edges && clients.edges.length > 0">
            <v-simple-table>
              <thead>
                <tr>
                  <th class="text-left">Client</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                  <th class="text-left">Username</th>
                  <th class="text-left">Active subscription</th>
                  <th class="text-left">Profile</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="userProfile in clients.edges" :key="userProfile.node.id">
                  <td>
                    <router-link class="black--text font-weight-bold" :to="`/clients/${userProfile.node.user.id}`">
                      {{ userProfile.node.user.firstName }}
                      {{ userProfile.node.user.lastName }}
                    </router-link>
                  </td>
                  <td>{{ userProfile.node.user.email }}</td>
                  <td>{{ userProfile.node.phone }}</td>
                  <td>
                    {{ userProfile.node.user && userProfile.node.user.username }}
                  </td>
                  <td>
                    {{
                      userProfile.node.user.subscriptions.edges &&
                        userProfile.node.user.subscriptions.edges[0] &&
                        userProfile.node.user.subscriptions.edges[0].node.product &&
                        userProfile.node.user.subscriptions.edges[0].node.product.name
                    }}
                  </td>
                  <td>
                    <v-btn v-if="userProfile.node.user" small :to="'/clients/' + userProfile.node.user.id">
                      View Profile
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-text v-else>
            <v-alert type="info">
              Sorry there are no records which match your search
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { CLIENTS_QUERY, PRODUCTS_QUERY } from "@/constants/graphql/client/client";
import { CORPORATE_QUERY } from "@/graphql/queries/corporate";

export default {
  data() {
    return {
      clients: [],
      loading: true,
      data: {
        firstName_Icontains: "",
        lastName_Icontains: "",
        phone_Icontains: "",
        email_Icontains: "",
        hubspotContactVid_Icontains: "",
        user_CorporateChallenges_CorporateChallengeId: "",
        user_Subscriptions_Product_Type: "",
      },
      search: {},
    };
  },
  methods: {
    submitSearch() {
      if (this.data.user_Subscriptions_Product_Type != "") {
        this.data.user_Subscriptions_Active = true;
      }

      let filter = Object.fromEntries(Object.entries(this.data).filter(([_, v]) => v != ""));
      this.loading = true;
      this.search = filter;
    },
    clearSearch() {
      this.data = {
        firstName_Icontains: "",
        lastName_Icontains: "",
        phone_Icontains: "",
        email_Icontains: "",
        hubspotContactVid_Icontains: "",
        user_CorporateChallenges_CorporateChallengeId: "",
        user_Subscriptions_Product_Type: "",
      };
      this.submitSearch();
    },
  },
  apollo: {
    clients: {
      query: CLIENTS_QUERY,
      variables() {
        return this.search;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
    },
    corporateChallenges: {
      query: CORPORATE_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.corporateChallenges.map((cc) => {
          return {
            text: cc.title,
            value: btoa("CorporateChallengeNode:" + cc.id),
          };
        });
      },
    },
    products: {
      query: PRODUCTS_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.__type.enumValues.map((prod) => {
          return prod.description.toLowerCase();
        });
      },
    },
  },
};
</script>
